import { get, set } from 'lodash';
import { DashboardJson } from '../../../models';
import { CONTAINED_WIDGET_JSON_POINTERS, UNCONTAINED_WIDGET_JSON_POINTERS } from '../constants';
import { WidgetProps } from '../models';

export const getWidgetTemplateWithUpdatedWidgetProps = (
  widgetTemplate: DashboardJson,
  props: WidgetProps,
): DashboardJson => {
  const widget = get(widgetTemplate, 'spec.widget');
  if (widget) {
    set(widgetTemplate, 'spec.widget', props);
    return widgetTemplate;
  } else {
    // use json pointers to set widget properties if spec.widget not available
    const widgetProps = props as WidgetProps;
    if (widgetProps.container) {
      set(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.CONTAINER.NAME, widgetProps.container.name);
      set(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.CONTAINER.PROPS, widgetProps.container.props ?? {});
      set(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.COMPONENT.NAME, widgetProps.component.name);
      set(widgetTemplate, CONTAINED_WIDGET_JSON_POINTERS.COMPONENT.PROPS, widgetProps.component.props ?? {});
    } else {
      set(widgetTemplate, UNCONTAINED_WIDGET_JSON_POINTERS.NAME, widgetProps.component.name);
      set(widgetTemplate, UNCONTAINED_WIDGET_JSON_POINTERS.PROPS, widgetProps.component.props ?? {});
    }
    return widgetTemplate;
  }
};
